import { Placeholder } from './style'
import { SpaceProps } from 'styled-system'

type Props = SpaceProps & {
  children: React.ReactNode
  onClick: () => void
  height: number | string
  width?: number | string
}

export const PreviewPlaceholder = ({
  children,
  height,
  width,
  onClick,
  ...space
}: Props) => {
  return (
    <Placeholder
      as="div"
      style={{ height, width }}
      onClick={onClick}
      {...space}
    >
      {children}
    </Placeholder>
  )
}

export default PreviewPlaceholder
